module.exports = __webpack_public_path__ + "img/2_184.53203916.png";